import styled from "styled-components"
import { StyledButton } from "../Buttons"
import { useCookies } from "react-cookie"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

interface Props {
  setIsUserMenuExpanded: React.Dispatch<React.SetStateAction<boolean>>
}

const ExpandedUserMenuDesktop = ({ setIsUserMenuExpanded }: Props) => {
  const [, , removeCookie] = useCookies(["accessToken", "user"])
  const navigate = useNavigate()

  const handleLogout = () => {
    removeCookie("accessToken", { path: "/" })
    removeCookie("user", { path: "/" })
    toast.success("성공적으로 로그아웃되었습니다.")
    navigate("/")
  }

  return (
    <HoverContainer
      onMouseEnter={() => setIsUserMenuExpanded(true)}
      onMouseLeave={() => setIsUserMenuExpanded(false)}
    >
      <ExpandedUserMenuDiv>
        <div style={{ fontSize: 14 }}>
          유저 프로필 정보 또는 유저 관련 메뉴 삽입 예정
        </div>
        <LogoutButton onClick={handleLogout}>로그아웃</LogoutButton>
      </ExpandedUserMenuDiv>
    </HoverContainer>
  )
}

export default ExpandedUserMenuDesktop

const HoverContainer = styled.div`
  position: absolute;
  top: 0px;
  right: -15px;
  padding: 20px 10px;
`

const ExpandedUserMenuDiv = styled.div`
  width: 150px;
  height: 200px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  padding: 10px;
  background-color: var(--custom-platinum);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
`

const LogoutButton = styled(StyledButton).attrs(() => ({
  $textColor: "var(--custom-light-red)",
  $size: "small",
  $hoverColor: "var(--custom-white-smoke)",
  $activeColor: "var(--custom-white-smoke)",
  $activeTextColor: "var(--custom-light-red)",
}))`
  border-radius: 10px;
  font-weight: bold;
  border: none;
`
